module.exports = __webpack_public_path__ + "img/AGRI.74095fe6.png";